<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
  <company-payment-show
    :data="payments"
    :slug="this.$route.params.slug"
    :role="role"
    :back="'/company/payments'"
  />
</b-overlay>
</template>

<script>
import Show from "../../../components/payment/Show";
export default {
  components: {
    "company-payment-show": Show
  },
  data() {
    return {
      payments: [],
      role: this.$store.getters.roles,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  created() {
    this.paymentShow(this.$route.params.id);
  },

  methods: {
    /**
     *
     * paymentShow   method  for list all payment data
     **/
    paymentShow(id) {
      this.show = true;

      this.$store
        .dispatch("PaymentShow", id)
        .then(res => {
          this.show = false;
          this.payments = res.data.data;
        })
        .catch(error => {
          this.$log.error(
            "File : List.vue | Function : getpayments() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error = this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    }
  }
};
</script>

<style lang="scss">
</style>
